var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgBudgetThumbnail(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 208,
    height: 152,
    viewBox: "0 0 208 152",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7 1C3.68629 1 1 3.68629 1 7V145C1 148.314 3.68629 151 7 151H201C204.314 151 207 148.314 207 145V7C207 3.6863 204.314 1 201 1H7Z",
    fill: "#F3F3F3",
    stroke: "#CDCDCD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5 32C40.567 32 39 33.567 39 35.5V35.5C39 37.433 40.567 39 42.5 39H185.5C187.433 39 189 37.433 189 35.5V35.5C189 33.567 187.433 32 185.5 32H42.5Z",
    fill: "#E1E1E1"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5 32C40.567 32 39 33.567 39 35.5V35.5C39 37.433 40.567 39 42.5 39H144.193C146.126 39 147.693 37.433 147.693 35.5V35.5C147.693 33.567 146.126 32 144.193 32H42.5Z",
    fill: "#D1D1D1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 46C27.5228 46 32 41.5228 32 36C32 30.4772 27.5228 26 22 26C16.4772 26 12 30.4772 12 36C12 41.5228 16.4772 46 22 46Z",
    fill: "#A6A8AB"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8002 39.102C24.7587 39.102 24.7172 39.0606 24.6758 39.0606V39.0606C24.0533 38.8116 23.182 38.3137 23.182 37.6083C23.182 36.5294 24.4268 36.3635 24.5928 34.1643C24.7173 32.3801 23.7629 31.0938 21.9787 31.0938C20.1944 31.0938 19.2401 32.3801 19.3646 34.1643C19.5305 36.405 20.7753 36.5709 20.7753 37.6083C20.7753 38.3137 19.904 38.8116 19.2816 39.0606V39.0606C19.2401 39.0606 19.1986 39.102 19.1571 39.102C18.8251 39.268 18.5762 39.6415 18.5762 40.0564C18.5762 40.6373 19.0326 41.0937 19.6135 41.0937H21.9787H24.3438C24.9247 41.0937 25.3811 40.6373 25.3811 40.0564C25.4226 39.6415 25.1737 39.268 24.8002 39.102V39.102Z",
    fill: "#BBBDBF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5 60C40.567 60 39 61.567 39 63.5V63.5C39 65.433 40.567 67 42.5 67H185.5C187.433 67 189 65.433 189 63.5V63.5C189 61.567 187.433 60 185.5 60H42.5Z",
    fill: "#E1E1E1"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5 60C40.567 60 39 61.567 39 63.5V63.5C39 65.433 40.567 67 42.5 67H123.252C125.185 67 126.752 65.433 126.752 63.5V63.5C126.752 61.567 125.185 60 123.252 60H42.5Z",
    fill: "#D1D1D1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 74C27.5228 74 32 69.5228 32 64C32 58.4772 27.5228 54 22 54C16.4772 54 12 58.4772 12 64C12 69.5228 16.4772 74 22 74Z",
    fill: "#A6A8AB"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8002 67.102C24.7587 67.102 24.7172 67.0606 24.6758 67.0606V67.0606C24.0533 66.8116 23.182 66.3137 23.182 65.6083C23.182 64.5294 24.4268 64.3635 24.5928 62.1643C24.7173 60.3801 23.7629 59.0938 21.9787 59.0938C20.1944 59.0938 19.2401 60.3801 19.3646 62.1643C19.5305 64.405 20.7753 64.5709 20.7753 65.6083C20.7753 66.3137 19.904 66.8116 19.2816 67.0606V67.0606C19.2401 67.0606 19.1986 67.102 19.1571 67.102C18.8251 67.268 18.5762 67.6415 18.5762 68.0564C18.5762 68.6373 19.0326 69.0937 19.6135 69.0937H21.9787H24.3438C24.9247 69.0937 25.3811 68.6373 25.3811 68.0564C25.4226 67.6415 25.1737 67.268 24.8002 67.102V67.102Z",
    fill: "#BBBDBF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5 88C40.567 88 39 89.567 39 91.5V91.5C39 93.433 40.567 95 42.5 95H185.5C187.433 95 189 93.433 189 91.5V91.5C189 89.567 187.433 88 185.5 88H42.5Z",
    fill: "#E1E1E1"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5 88C40.567 88 39 89.567 39 91.5V91.5C39 93.433 40.567 95 42.5 95H97.3254C99.2584 95 100.825 93.433 100.825 91.5V91.5C100.825 89.567 99.2584 88 97.3254 88H42.5Z",
    fill: "#D1D1D1"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 102C27.5228 102 32 97.5228 32 92C32 86.4772 27.5228 82 22 82C16.4772 82 12 86.4772 12 92C12 97.5228 16.4772 102 22 102Z",
    fill: "#A6A8AB"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8002 95.102C24.7587 95.102 24.7172 95.0606 24.6758 95.0606V95.0606C24.0533 94.8116 23.182 94.3137 23.182 93.6083C23.182 92.5294 24.4268 92.3635 24.5928 90.1643C24.7173 88.3801 23.7629 87.0938 21.9787 87.0938C20.1944 87.0938 19.2401 88.3801 19.3646 90.1643C19.5305 92.405 20.7753 92.5709 20.7753 93.6083C20.7753 94.3137 19.904 94.8116 19.2816 95.0606V95.0606C19.2401 95.0606 19.1986 95.102 19.1571 95.102C18.8251 95.268 18.5762 95.6415 18.5762 96.0564C18.5762 96.6373 19.0326 97.0937 19.6135 97.0937H21.9787H24.3438C24.9247 97.0937 25.3811 96.6373 25.3811 96.0564C25.4226 95.6415 25.1737 95.268 24.8002 95.102V95.102Z",
    fill: "#BBBDBF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.75,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5 116C40.567 116 39 117.567 39 119.5V119.5C39 121.433 40.567 123 42.5 123H185.5C187.433 123 189 121.433 189 119.5V119.5C189 117.567 187.433 116 185.5 116H42.5Z",
    fill: "#E1E1E1"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M42.5 116C40.567 116 39 117.567 39 119.5V119.5C39 121.433 40.567 123 42.5 123H82.3676C84.3006 123 85.8676 121.433 85.8676 119.5V119.5C85.8676 117.567 84.3006 116 82.3676 116H42.5Z",
    fill: "#D1D1D1"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.25,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22 130C27.5228 130 32 125.523 32 120C32 114.477 27.5228 110 22 110C16.4772 110 12 114.477 12 120C12 125.523 16.4772 130 22 130Z",
    fill: "#A6A8AB"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.85,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.8002 123.102C24.7587 123.102 24.7172 123.061 24.6758 123.061V123.061C24.0533 122.812 23.182 122.314 23.182 121.608C23.182 120.529 24.4268 120.363 24.5928 118.164C24.7173 116.38 23.7629 115.094 21.9787 115.094C20.1944 115.094 19.2401 116.38 19.3646 118.164C19.5305 120.405 20.7753 120.571 20.7753 121.608C20.7753 122.314 19.904 122.812 19.2816 123.061V123.061C19.2401 123.061 19.1986 123.102 19.1571 123.102C18.8251 123.268 18.5762 123.641 18.5762 124.056C18.5762 124.637 19.0326 125.094 19.6135 125.094H21.9787H24.3438C24.9247 125.094 25.3811 124.637 25.3811 124.056C25.4226 123.641 25.1737 123.268 24.8002 123.102V123.102Z",
    fill: "#BBBDBF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBudgetThumbnail);
export default __webpack_public_path__ + "static/media/budget-thumbnail.53f8d85d4cc841653dcd46e8d55b72c6.svg";
export { ForwardRef as ReactComponent };